import React, {useEffect, useState} from "react";
import general from "../../general";
import $ from "jquery";
import {Link} from "react-router-dom";
import {useScroll, useThrottleEffect} from "ahooks";
import Dialog from "../../lib/Dialog";
import Image from "../../lib/Image";
import useActiveState from "../../lib/useActiveState";
import Subtitle from "../components/Subtitle";
import Manager from "../components/Manager";
import { useLockFn } from "ahooks";
import {NavLink} from "../../lib/Navigation";
import FreeEdition from "../components/FreeEdition";
import GameTags from "../components/game/GameTags";

export default ({active, kw,refresh}) => {
  
  const [agent] = useActiveState('agent');
  const [init, setInit] = useState();
  const [loading, setLoading] = useState();
  const [page, setPage] = useState(1);
  const [games, setGames] = useState([]);
  const [more, setMore] = useState(true);
  const [user] = useActiveState('user');
  const [recommendWords, setRecommendWords] = useState();
  const [randomColorInfo] = useActiveState('randomColorInfo');
  const [applydata, setApplydata] = useState({});
  const [applyState, setApplyState] = useState(false);
  const [reservationGame, setReservationGame] = useState(false);

  const load = (parms = {}) => {
    Manager.push({event_id:'B-1-1',data:{kwd:kw}})
    if (loading) {
      return;
    }
    setLoading(true);
    Dialog.loading();
    let tmp = {
      game_species_type: 0,
      is_search: true,
      search_info: kw,
      pagination: {page: page},
    };
    if (parms.page) {
      tmp.pagination = {page: parms.page};
    }
    general.axios.post('/base/searchGame/search', tmp)
        .finally(() => {
          setLoading(false);
          Dialog.close();
        })
        .then(response => {
          setInit(true);
          let result = response.data.data;
          if (parms.page) {
            setPage(parms.page);
          }

          result?.gameList?.forEach(d => {
            d.infoColor = randomColorInfo[parseInt(Math.random() * 4)]
          })
          setGames(games => parms.page === 1 || !parms.page ? result.gameList : [...games, ...result.gameList]);
          setMore(result.paginated.more);
          setRecommendWords(result.recommendWords);
          setReservationGame(result.reservationGame ? true : false);

          
        })
        .catch(err => {
          Dialog.error(err.message);
        });
  }
  useEffect(() => {
    if (kw) {
      load({page: 1});
    }
  }, [kw, refresh]);

  const scroll = useScroll();
  useEffect(() => {
    if (active && init) {
      if (scroll.top < -80) {
        load({page: 1});
      }
      if (scroll.top + window.innerHeight + 20 > $(document).height() && more) {
        load({page: page + 1});
      }
    }
  }, [scroll, active]);

  const applySearchGame = useLockFn(() => {
    if(!applydata.gamename) {
      Dialog.info('请输入游戏名称');
      return;
    }
    
    Dialog.loading();

    general.axios.post('/reservationGameSubmit', {name:applydata.gamename, content:applydata.argument})
      .finally(() => {
        Dialog.close();
      })
      .then(response => {
        let result = response.data;
        if (!result.status.succeed) {
          Dialog.error(result.status.error_desc);
        } else {
          Dialog.info('提交成功');
          setApplyState(false);
        }
      })
      .catch(error => {
        Dialog.error(error.message);
      });
  })

  const handleComposition = (e) => {
    // console.log(e.type + ": " + e.target.value);
    // console.log(inputFlag);
    
    if (e.type === 'compositionend') {
      // composition is end
      const value = e.target.value;

      setApplydata({ ...applydata, argument: e.target.value })
      return;

    } else if (e.type === 'compositionstart') {

      return;
    } else if (e.type === 'compositionupdate') {

      return;
    }
    
  }

  return <div className={'search-result ' + (kw ? 'active' : '')}>
    {recommendWords ?
    <div className="search-empty">{recommendWords}</div>
    : null}

    {reservationGame ?
    <div className="search-empty-apply">
      没找到想玩的游戏，<NavLink className="tap-apply" user={true} onClick={()=>{if(general.isLogin()) {setApplyState(true)}  }}>点击申请游戏</NavLink>
    </div>
    : null}

    {games?.map(game => <Link onClick={()=>Manager.push({event_id:'B-1-2',data:{gameid:game.maiyou_gameid,kwd:kw}})} to={'/game?id=' + game.game_id + '&source=searchHistory&agent='+agent} className="item">
      <div className="icon">
        <Image src={game.game_image.thumb}/>
      </div>
      <div className="text">
        <div className="name">
          <div className="named" style={{width: game.discount < 1 ? '83%' : '100%' }}>
            {/* {game.top_lable != '' ? <span>{game.top_lable }</span> : null }{game.game_name} */}
            <div className={" " + (game.nameRemark ? " name-new" : "")}>
              {game.top_lable != '' ? <span className="span">{game.top_lable }</span> : null }
              {game.game_name}
            </div>
          </div>
          <div className="authpic">
          {/* {game.is_ocp == 1 ? <img src="/resources/search/auth.gif" /> : null} */}
          {game.is_ocp == 1 ? <img src="/resources/search/new-auth.png" /> : null}
          </div>
        </div>
        <div className="info1">
          {/* {
            game.nameRemark ?
            <span className="nameRemark">
              {game?.nameRemark}&nbsp;
            </span>
            : null
          } */}
          <div className="scrole-stat">
            <img src="/resources/game/score.png" />
            <span>{game.score}</span>
          </div>
          {game.game_classify_type.trim()}
          <Subtitle>{game.nameRemark}</Subtitle>
        </div>
        <GameTags game={game}></GameTags>
        {/* {game.discount < 1 ? <div className="discount" ><span>{game.discount * 10}</span>折</div> : null} */}
      </div>
      {/* <div className="btn">{game.game_species_type != 3 ? '下载' : '开始'}</div> */}

      {/* {
        game.game_species_type != 1 || (game.game_species_type == 1 && game.discount < 1 && game.discount > 0) ?
        <div className="discount" >
          <div className="number">
            {(()=>{
              if(game.discount < 1 ) {
                return <><span>{(game.discount * 10)}</span>折</>
              }
            })()}
          </div>
        </div>
        : null
      } */}
      <FreeEdition>{game}</FreeEdition>
    </Link>)}
    {/* {games.length === 0 && init ? <div className="search-empty">
      <img src="/resources/search/empty.png" alt=""/>
      搜索"{kw}"没有找到任何数据
    </div> : null} */}
    {games?.length > 6 ? <div className="view-end">别撩啦！已经到底啦~</div> : null}

    {applyState ?
    <div className="alert-search-apply-index">
      <div className="apply-mask" />
      <div className="alert-search-apply-content">
        <div className="close" onClick={()=>setApplyState(false)}>
          <img src="/resources/user/close.png" />
        </div>
        <div className="title">游戏申请</div>
        <div className="tips">输入您感兴趣的游戏名，我们会根据您的意见更新游戏</div>
        <div>
          <div className="input-header"><span>*</span>游戏名称：</div>
          <div className="input-item">
            <div className="input auth-input">
              <input name="gamename" type="text" value={applydata.gamename || ''} placeholder="请输入游戏名"
                onFocus={e => setFocus('gamename')}
                onChange={e => setApplydata({ ...applydata, gamename: e.target.value })}
              />
            </div>
          </div>
          <div className="input-header argument-header">游戏推荐理由： <span>{applydata?.argument?.length || 0}/100</span></div>
          <div className="input-item">
            <div className="input auth-input">
              <textarea name="argument" placeholder="如可玩性高、福利多、游戏玩法多样等" 
                onFocus={e => setFocus('argument')}
                onCompositionStart = {handleComposition}
                onCompositionUpdate = {handleComposition}
                onCompositionEnd = {handleComposition}
                // onChange={e => setApplydata({ ...applydata, argument: e.target.value })}
              ></textarea>
            </div>
          </div>
        </div>
        <div className={'operate '} onClick={() => {applySearchGame()}}>提交</div>
      </div>
    </div>
    : null}
  </div>;
};